import { Action } from '@ngrx/store';
import { Invoice } from '../../shared/models/invoice';
import { Prestation } from '../../shared/models/prestation';
export const LOAD_INVOICES = '[Invoice] Load invoices...';
export const LOAD_INVOICES_SUCCESS = '[Invoice] Load invoices success...';
export const LOAD_INVOICES_ERROR = '[Invoice] Load invoices error...';
export const LOAD_INVOICE = '[Invoice] Load invoice...';
export const LOAD_INVOICE_SUCCESS = '[Invoice] Load invoice success...';
export const LOAD_INVOICE_ERROR = '[Invoice] Load invoice error...';
export const OPEN_TAB = '[Invoice] open tab...';
export const CLOSE_TAB = '[Invoice] close tab...';
export const SAVE_INVOICE = '[Invoice] Save invoice...';
export const SAVE_INVOICE_SUCCESS = '[Invoice] Save invoice success...';
export const SAVE_INVOICE_ERROR = '[Invoice] Save invoice error...';
export const ADD_INVOICE = '[Invoice] Add invoice...';
export const INVOICE_WORKFLOW = '[Invoice] do action...';
export const INVOICE_WORKFLOW_SUCCESS = '[Invoice] do action success...';
export const INVOICE_WORKFLOW_ERROR = '[Invoice] do action error...';
export const DELETE_INVOICE = '[Invoice] delete invoice...';
export const DELETE_INVOICE_SUCCESS = '[Invoice] delete invoice success...';
export const DELETE_INVOICE_ERROR = '[Invoice] delete invoice error...';
export const SAVE_PAIEMENTS = '[Invoice] save paiments...';

export class LoadInvoicesAction implements Action {
    readonly type = LOAD_INVOICES;
    constructor(
		public sortField: string,
		public sortOrder: number,
		public filters: any,
		public first: number,
		public rows: number,
        public outInvoices: boolean = true		
    ) {    	
    }    
}

export class LoadInvoicesSuccessAction implements Action {
    readonly type = LOAD_INVOICES_SUCCESS;
    constructor ( public invoices: any[], public totalCount: number ) {}    
}

export class LoadInvoicesErrorAction implements Action {
    readonly type = LOAD_INVOICES_ERROR;
    constructor ( public error: any ) {}    
}

export class LoadInvoiceAction implements Action {
    readonly type = LOAD_INVOICE;
    constructor(
        public id: number,        
    ) {        
    }    
}

export class LoadInvoiceSuccessAction implements Action {
    readonly type = LOAD_INVOICE_SUCCESS;
    constructor ( public invoice: any) {}    
}

export class LoadInvoiceErrorAction implements Action {
    readonly type = LOAD_INVOICE_ERROR;
    constructor ( public error: any ) {}    
}

export class CloseTabAction implements Action {
    readonly type = CLOSE_TAB;
    constructor ( public id: number ) {}    
}

export class OpenTabAction implements Action {
    readonly type = OPEN_TAB;
    constructor ( public id: number ) {}    
}


export class SaveInvoiceAction implements Action {
    readonly type = SAVE_INVOICE;
    constructor(
        public invoice: Invoice,        
    ) {        
    }    
}

export class SaveInvoiceSuccessAction implements Action {
    readonly type = SAVE_INVOICE_SUCCESS;
    constructor (        public id: number, public invoice: any) {}    
}

export class SaveInvoiceErrorAction implements Action {
    readonly type = SAVE_INVOICE_ERROR;
    constructor ( public id:number,  public error: any ) {}    
}

export class AddInvoiceAction implements Action {
    readonly type = ADD_INVOICE;
    constructor ( public typeInvoice: number = 1) {}    
}

export class InvoiceWorkflowAction implements Action {
    readonly type = INVOICE_WORKFLOW;
    constructor (public id:number,  public action: any ) {}    
}
export class InvoiceWorkflowSuccessAction implements Action {
    readonly type = SAVE_INVOICE_SUCCESS;
    constructor (        public id: number, public invoice: any) {}    
}

export class InvoiceWorkflowErrorAction implements Action {
    readonly type = INVOICE_WORKFLOW_ERROR;
    constructor ( public id:number,  public error: any ) {}    
}



export class DeleteInvoiceAction implements Action {
    readonly type = DELETE_INVOICE;
    constructor (public id:number ) {}    
}
export class DeleteInvoiceSuccessAction implements Action {
    readonly type = DELETE_INVOICE_SUCCESS;
    constructor ( public id: number ) {}    
}

export class DeleteInvoiceErrorAction implements Action {
    readonly type = DELETE_INVOICE_ERROR;
    constructor ( public id:number,  public error: any ) {}    
}

export class SavePaiementsAction implements Action {
    readonly type = SAVE_PAIEMENTS;
    constructor (public id:number, public paiements: any[] ) {}    
}


export type invoiceActions = LoadInvoicesAction | LoadInvoicesSuccessAction |
LoadInvoicesErrorAction | LoadInvoiceAction | LoadInvoiceSuccessAction |
LoadInvoiceErrorAction | OpenTabAction | CloseTabAction | SaveInvoiceAction | SaveInvoiceSuccessAction |
SaveInvoiceErrorAction | AddInvoiceAction |InvoiceWorkflowAction | InvoiceWorkflowErrorAction | 
InvoiceWorkflowSuccessAction |DeleteInvoiceAction | DeleteInvoiceErrorAction | 
DeleteInvoiceSuccessAction | SavePaiementsAction 
;
